// Tiny safe renderer for AI replies: **bold**, bullet / numbered lists and paragraphs. Never injects HTML.
const inline = (text) =>
  text.split(/(\*\*[^*]+\*\*)/g).map((part, i) =>
    part.startsWith("**") && part.endsWith("**")
      ? <strong key={i} className="font-semibold text-stone-50">{part.slice(2, -2)}</strong>
      : <span key={i}>{part}</span>);

export const RichText = ({ text }) => {
  const blocks = [];
  (text ?? "").split("\n").forEach((raw) => {
    const line = raw.trim();
    const item = line.match(/^(?:[-*•]|\d+[.)])\s+(.*)$/);
    const last = blocks[blocks.length - 1];
    if (item) {
      if (last?.type === "list") last.items.push(item[1]);
      else blocks.push({ type: "list", ordered: /^\d/.test(line), items: [item[1]] });
    } else if (line) {
      blocks.push({ type: "p", text: line });
    }
  });
  return (
    <div className="space-y-2">
      {blocks.map((b, i) => {
        if (b.type === "p") {
          const general = b.text.startsWith("General guidance:");
          return (
            <p key={i} className={general ? "rounded-lg border-l-2 border-sky-400/60 bg-sky-400/5 py-1 pl-3 text-stone-300" : ""}>
              {inline(b.text)}
            </p>
          );
        }
        const List = b.ordered ? "ol" : "ul";
        return (
          <List key={i} className={`space-y-1 pl-5 ${b.ordered ? "list-decimal" : "list-disc"} marker:text-orange-400`}>
            {b.items.map((t, j) => <li key={j}>{inline(t)}</li>)}
          </List>
        );
      })}
    </div>
  );
};
